export const platformAccess = {
  junior: {
    required: [
      { platform: 'JIRA', access: 'Developer', purpose: 'Bug tracking and test management', setup: 'Request access to QA projects' },
      { platform: 'TestRail', access: 'Tester', purpose: 'Test case management and execution', setup: 'Request tester role in TestRail' },
      { platform: 'GitHub', access: 'Developer', purpose: 'Test automation code access', setup: 'Request access to test automation repos' },
      { platform: 'Slack', access: 'Member', purpose: 'QA team communication', setup: 'Join #qa-team, #bug-reports, #test-automation' }
    ],
    optional: [
      { platform: 'Postman Team', access: 'Collaborator', purpose: 'Shared API test collections', setup: 'Join QA team workspace' },
      { platform: 'BrowserStack', access: 'User', purpose: 'Cross-browser testing', setup: 'Request testing account' }
    ]
  },
  mid: {
    required: [
      { platform: 'Jenkins', access: 'Developer', purpose: 'CI/CD test integration', setup: 'Request build and deployment permissions' },
      { platform: 'Selenium Grid', access: 'Admin', purpose: 'Test execution management', setup: 'Request grid administration access' },
      { platform: 'Allure Reports', access: 'Editor', purpose: 'Test reporting and analytics', setup: 'Request report generation permissions' },
      { platform: 'Docker Hub', access: 'Developer', purpose: 'Test environment containers', setup: 'Join QA organization team' }
    ],
    optional: [
      { platform: 'AWS Console', access: 'Developer', purpose: 'Test environment management', setup: 'Request IAM permissions for test resources' },
      { platform: 'Datadog', access: 'Standard', purpose: 'Test monitoring and metrics', setup: 'Request monitoring dashboard access' }
    ]
  },
  senior: {
    required: [
      { platform: 'TestRail', access: 'Admin', purpose: 'Test management platform administration', setup: 'Request admin role' },
      { platform: 'JIRA', access: 'Admin', purpose: 'QA project and workflow management', setup: 'Request project admin permissions' },
      { platform: 'Jenkins', access: 'Admin', purpose: 'CI/CD pipeline management', setup: 'Request admin permissions' },
      { platform: 'Quality Dashboards', access: 'Admin', purpose: 'Quality metrics and KPI management', setup: 'Request dashboard admin access' }
    ],
    optional: [
      { platform: 'Grafana', access: 'Admin', purpose: 'Test metrics visualization', setup: 'Request admin permissions' },
      { platform: 'ELK Stack', access: 'Admin', purpose: 'Test log analysis', setup: 'Request Elasticsearch admin access' }
    ]
  }
};
